import { gsap, Observer } from '../global/gsap';

const initCursor = (cursorEls) => {
    const mm = gsap.matchMedia();

    mm.add('(min-width: 901px)', () => {
        // set up pill
        const pill = document.createElement('span');
        pill.classList.add('pill-btn');
        document.body.appendChild(pill);

        gsap.set(pill, {
            xPercent: -40,
            yPercent: 10,
            opacity: 0,
            transformOrigin: 'center top'
        });

        const xTo = gsap.quickTo(pill, 'x', { duration: 0.6, ease: 'power4.out' });
        const yTo = gsap.quickTo(pill, 'y', { duration: 0.6, ease: 'power4.out' });
        const rotTo = gsap.quickTo(pill, 'rotation', { duration: 0.4, ease: 'power2' });

        let currentContainer = null;

        const updatePill = (container) => {
            // update btn text
            const titleText = container.getAttribute('data-cursor-text') || 'Explore';
            const oldWidth = pill.offsetWidth;
            pill.innerHTML = titleText;

            // animate width
            gsap.set(pill, { width: 'auto' });
            const newWidth = pill.offsetWidth;

            gsap.fromTo(pill,
                { width: oldWidth },
                {
                    width: newWidth,
                    duration: 0.4,
                    ease: 'power3.out',
                    overwrite: 'auto',
                    onComplete: () => gsap.set(pill, { width: 'auto' })
                }
            );
        };

        const obs = Observer.create({
            target: window,
            type: 'pointer, touch, scroll',
            onMove: (self) => {
                xTo(self.x);
                yTo(self.y);

                // Dynamic Rotation based on velocity
                const rotation = gsap.utils.clamp(-25, 25, self.deltaX * 0.4);
                rotTo(rotation);

                // If we are over a container but the pill is hidden (e.g. after scroll)
                if (currentContainer && gsap.getProperty(pill, 'opacity') < 0.1) {
                    gsap.to(pill, { opacity: 1, duration: 0.4, overwrite: 'auto' });
                }
            }
        });

        const onEnter = (e) => {
            const container = e.currentTarget;
            currentContainer = container;
            updatePill(container);

            xTo(e.clientX);
            yTo(e.clientY);

            gsap.to(pill, {
                opacity: 1,
                duration: 0.4,
                overwrite: 'auto'
            });
        };

        const onLeave = () => {
            currentContainer = null;
            gsap.to(pill, {
                opacity: 0,
                duration: 0.4,
                overwrite: 'auto'
            });
        };

        cursorEls.forEach((container) => {
            container.addEventListener('mouseenter', onEnter);
            container.addEventListener('mouseleave', onLeave);
        });

        return () => {
            obs.kill();
            cursorEls.forEach((container) => {
                container.removeEventListener('mouseenter', onEnter);
                container.removeEventListener('mouseleave', onLeave);
            });

            if (pill.parentNode) {
                pill.parentNode.removeChild(pill);
            }
        };
    });
};

export { initCursor as default };
